'use strict';
(self.webpackChunkyourkaya = self.webpackChunkyourkaya || []).push([
  [5367],
  {
    1408: (e, t, s) => {
      var i = s(9897),
        r = Object.defineProperty,
        o = (e, t, s) => (
          ((e, t, s) => {
            t in e ? r(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : (e[t] = s);
          })(e, 'symbol' != typeof t ? t + '' : t, s),
          s
        );
      class l extends i.oi {
        constructor() {
          var e;
          super(),
            o(this, 'onInput', (e) => {
              var t, s, i;
              if (((this.inputValue = e.target.value), !this.inputValue))
                return (this.errorMessage = ''), void (null == (t = this.inputElement) || t.classList.remove('error'));
              const r = new RegExp(this.validationRegexp, ''),
                o = !!this.inputValue.match(r);
              (this.isInputValid = o),
                (this.errorMessage = this.isInputValid ? '' : this.regexpErrorMessage),
                this.isInputValid
                  ? null == (i = this.inputElement) || i.classList.remove('error')
                  : null == (s = this.inputElement) || s.classList.add('error');
            }),
            o(this, 'onFocus', () => {
              var e;
              null == (e = this.shadowRoot.querySelector('.placeholder')) || e.classList.add('offset-placeholder');
            }),
            o(this, 'onBlur', () => {
              var e;
              this.inputValue ||
                null == (e = this.shadowRoot.querySelector('.placeholder')) ||
                e.classList.remove('offset-placeholder');
            }),
            o(this, 'onSubmit', () => {
              var e;
              this.isCheckbox &&
                !this.checkboxChecked &&
                ((this.errorMessage = this.checkboxErrorMessage),
                null == (e = this.querySelector('.label-container .icon-checkbox-light')) || e.classList.add('error')),
                this.inputValue || (this.errorMessage = this.regexpErrorMessage);

              const data = {
                event: 'newsletter_submit',
                user_id: window.customerData?.id ? window.customerData?.id : '',
                section: 'newsletter_section',
                element: 'newsletter_section_button',
                interaction_type: 'click',
              };

              dataLayer.push(data);
              console.log('Form submitted on:', window.location.href);
            }),
            o(this, 'onCheckboxChange', (e) => {
              var t;
              (this.checkboxChecked = e.target.checked),
                !0 === this.checkboxChecked &&
                  this.errorMessage === this.checkboxErrorMessage &&
                  ((this.errorMessage = ''),
                  null == (t = this.querySelector('.label-container .icon-checkbox-light')) ||
                    t.classList.remove('error'));
            }),
            (this.stylesheet =
              (null == (e = this.querySelector('[slot="stylesheet"]')) ? void 0 : e.cloneNode(!0)) || null),
            (this.inputElement = this.querySelector('[slot="input"') || null),
            (this.inputValue = ''),
            (this.placeholder = void 0),
            (this.hidePlaceholderOnOffset = !1),
            (this.validationRegexp = void 0),
            (this.isInputValid = !0),
            (this.regexpErrorMessage = ''),
            (this.checkboxErrorMessage = ''),
            (this.errorMessage = ''),
            (this.inlineButton = !1),
            (this.isCheckbox = !!this.querySelector('[slot="checkbox"]')),
            (this.checkboxChecked = !1),
            this.initializeInput(this.inputElement);
        }
        static get properties() {
          return {
            placeholder: { type: String },
            hidePlaceholderOnOffset: { attribute: 'hide-placeholder-on-offset', type: Boolean },
            validationRegexp: { attribute: 'validation-regexp', type: String },
            regexpErrorMessage: { attribute: 'regexp-error-message', type: String },
            checkboxErrorMessage: { attribute: 'checkbox-error-message', type: String },
            errorMessage: { attribute: 'error-message', type: String },
            inlineButton: { attribute: 'inline-button', type: Boolean },
            isInputValid: { type: Boolean },
          };
        }
        initializeInput(e) {
          e &&
            (e.addEventListener('input', this.onInput),
            e.addEventListener('focus', this.onFocus),
            e.addEventListener('blur', this.onBlur),
            (this.inputValue = e.value || ''));
        }
        firstUpdated() {
          var e, t;
          super.firstUpdated(),
            this.inputValue &&
              (null == (t = null == (e = this.shadowRoot) ? void 0 : e.querySelector('.placeholder')) ||
                t.classList.add('offset-placeholder'));
        }
        render() {
          const e = this.errorMessage ? i.dy`<span class="error-message">${this.errorMessage}</span>` : '',
            t = this.hidePlaceholderOnOffset ? 'hide-on-offset' : '',
            s = this.placeholder ? i.dy`<span class="placeholder ${t}">${this.placeholder}</span>` : '';
          return i.dy`
      ${this.stylesheet}
      <div class="ba-input-validation">
        <div class="input-container ${this.inlineButton ? 'inline-button' : ''}">
          ${e}
          <slot name="input"></slot>
          ${s}
          <slot name="button" @click="${this.onSubmit}"></slot>
        </div>
        <slot name="checkbox" class="checkbox-container" @change="${this.onCheckboxChange}"></slot>
      </div>
    `;
        }
      }
      window.customElements.define('ba-input-validation', l);
    },
  },
  (e) => {
    e.O(0, [1216], () => {
      return (t = 1408), e((e.s = t));
      var t;
    });
    e.O();
  },
]);
